import Constant from 'BASE/common/lotteryConstant';
import { storage } from 'BASE/common/util/util.storage';

const STORAGE_EXPIRE = () => Date.now() + 60 * 60 * 1000;
const BET_INFO_MAX_DATA_LENGTH = 2.5 * 1024 * 1024;

async function get(loginId) {
    if (!loginId) {
        return [];
    }

    let key = storage.keys.COLLECTION_PREFIX + loginId;
    let collection = storage.local.get(key);

    if (collection != null && !Array.isArray(collection)) {
        console.error('collection get from storage return invalid data format: ', collection);
        storage.local.remove(key);
        collection = null;
    }

    if (!collection) {
        collection = await $.post('/api/Collection/Get');

        // clean other account collection
        for (let storageKey in localStorage) {
            if (storageKey.startsWith(storage.keys.COLLECTION_PREFIX)) {
                let storageKeyLoginId = storageKey.replace(storage.keys.COLLECTION_PREFIX, '');
                if (storageKeyLoginId != loginId) {
                    storage.local.remove(storageKey);
                }
            }
        }

        if (!Array.isArray(collection)) {
            throw new Error('collection get api response invalid data format: ' + collection);
        }

        storage.local.set(key, collection, STORAGE_EXPIRE());
    }

    return collection;
}

export async function getCollection(loginId, inputType) {
    if (loginId) {
        let collection = await get(loginId);
        if (!inputType) {
            inputType = Constant.CollectionType.GAME
        }

        let collectionType = inputType;
        let c = collection.find(c => Constant.CollectionType[c.Type] == collectionType);
        if (c && c.Data) {
            return JSON.parse(c.Data);
        }
    }
    return [];
}

export async function setCollection(loginId, gameIdArr, inputType) {
    if (!loginId) {
        return;
    }

    let key = storage.keys.COLLECTION_PREFIX + loginId;

    if (!inputType) inputType = Constant.CollectionType.GAME;
    let collectionType = inputType;

    if (gameIdArr.length <= 0) {        
        if (await $.postJSON('/api/Collection/DeleteCollection', { Type: collectionType })) {
            let collection = await get(loginId);
            let index = collection.findIndex(c => Constant.CollectionType[c.Type] == collectionType);
            if (index >= 0) {
                collection.splice(index, 1);
            }
            storage.local.set(key, collection, STORAGE_EXPIRE());
        }
        return;
    }
    try {
        let _setData = { DataList: gameIdArr, Type: collectionType };
        let resp = await $.postJSON('/api/Collection/SetCollection', _setData);
        if (resp) {
            let collection = await get(loginId);
            let index = collection.findIndex(c => Constant.CollectionType[c.Type] == collectionType);
            if (index >= 0) {
                collection.splice(index, 1, resp);
            } else {
                collection.push(resp);
            }
            storage.local.set(key, collection, STORAGE_EXPIRE());
        }
    } catch (error) {
        console.error(error);
    }
}

export async function setCollectionFromNotification(list, loginId) {
    if (!Array.isArray(list)) {
        console.error('collection received invalid data format: ', list);
        return;
    }

    let key = storage.keys.COLLECTION_PREFIX + loginId;
    storage.local.set(key, list, STORAGE_EXPIRE());
}

//投注收藏
export const setBetInfoResult = {
    SUCCESS: 0,
    FAILED: 1,
    EXCEED: 2,
};
export async function setBetInfo(loginId, betInfoArr ,callback) {
    if (!loginId) {
        return setBetInfoResult.FAILED;
    }

    let collection = await get(loginId);
    let betInfoLength = JSON.stringify(betInfoArr).length
    let totalBetInfoLength = collection
        .filter((c) => Constant.CollectionType[c.Type] == Constant.CollectionType.BET_INFO)
        .reduce((acc, c) => acc + JSON.stringify(c).length, betInfoLength);
    if (totalBetInfoLength > BET_INFO_MAX_DATA_LENGTH) {
        return setBetInfoResult.EXCEED;
    }

    let resp = await $.postJSON('/api/Collection/SetBetInfo', betInfoArr);
    if (resp) {
        await get(loginId);
        callback();
        return setBetInfoResult.SUCCESS;
    }

    return setBetInfoResult.FAILED;
}

export async function removeBetInfoByID(loginId, betInfoID) {
    if (loginId) {
        let key = storage.keys.COLLECTION_PREFIX + loginId;
        if (await $.post(`/api/Collection/DeleteBetInfoByID/${betInfoID}`)) {
            let collection = await get(loginId);
            let index = collection.findIndex(c => Constant.CollectionType[c.Type] == Constant.CollectionType.BET_INFO && c.ID == betInfoID);
            if (index >= 0) {
                collection.splice(index, 1);
            }
            storage.local.set(key, collection, STORAGE_EXPIRE());
        }
        return;
    }
}

export async function getBetInfo(loginId) {
    if (loginId) {

        let collection = await get(loginId);
        let betinfoAry = [];
        $.each(collection, function (idx, item) {
            if (Constant.CollectionType[item.Type] == Constant.CollectionType.BET_INFO) {
                betinfoAry.push({
                    ID: item.ID,
                    data: JSON.parse(item.Data)
                });
            }
        })
        return betinfoAry;
    }
    return [];
}


export function mergeInfo(collected, objs) {
    let res = [];
    if (!collected || objs.some(o => !o)) {
        return res;
    }

    for (let c of collected) {
        let infos = objs.map(o => o[c]);
        if (infos.every(i => i)) {
            res.push(Object.assign({ Id: c }, ...infos));
        }
    }

    return res;
}